<template>
  <div>
    <div class="content-header">
      <div class="clearfix">
        <h1 class="header-form-loan-info text-uppercase mb-4 float-left">{{ $t('diInvestmentList')}}</h1>
         <router-link class="active ml-2 text-white" :to="{ name: 'addInvesmentLender' }">      
          <button type="button" class="btn-success btn-rounded text-uppercase float-right btn">{{ $t('plAdd')}}</button>
        </router-link>
      </div>
    </div>

    <div class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            {{ $t('table.currency')}}:
            <select  @change="fetchInvestments" v-model="filterCurrency" class="mb-5" >
              <option value="" selected="selected">{{ $t('table.chooseCurrency')}}</option>
              <option v-for="option in currencyOptions" :key="option.value" :value="option.value">
                {{option.value}}
              </option>
            </select>
            <div class="card">
              <v-client-table :data="investments" 
                :columns="tableHeaders"
                :options="options"
              >
                <a slot="action" slot-scope="props" 
                  :href="edit(props.row._id)"
                >
                  Edit
                </a>
              </v-client-table>
            </div>
          </div>
        </div>
      </div>

      <p class="vue-pagination-ad"></p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Paginate from '@/components/Paginate.vue'
import moment from 'moment'

export default {
  name: "adminInvestment",
  data() {
    return {
      investments: [],
      filterCurrency: '',
      tableHeaders: ['investmentId', 'priorityUser.name', 'investmentDate', 'currency', 'amount', 'timePeriod', 'status', 'action'],
      options: {
        sortable: ['investmentId', 'priorityUser.name', 'investmentDate', 'currency', 'amount', 'timePeriod', 'status'],
        sortIcon: {
          base : 'fa',
          is: 'fa-sort',
          up: 'fa-sort-up',
          down: 'fa-sort-down'
        },
        headings: {
          'priorityUser.name': 'Name'
        },
        templates: {
          investmentDate() {
            return moment(this.investmentDate).format('D MMMM YYYY')
          },
          amount(h, row) {
            return this.$options.filters.displayAmount(row.amount, row.currency);
          }
        }
      }
    };
  },
  components:{
    Paginate
  },
  computed: {
    ...mapState([
      'currencyOptions'
    ])
  },
  mounted() {
    if(this.$route.query && this.$route.query.currency) {
      this.filterCurrency = this.$route.query.currency.toUpperCase()
    }
    this.fetchInvestments()
  },
  methods:{
    edit(id) {
      let props = this.$router.resolve({ 
        name: 'adminInvestmentUpdate',
        params: { id: id },
      });
      return props.href
    },
    fetchInvestments() {
      let url = '/admin/v1/priority/investments'
      if(this.filterCurrency) {
        url += `/?currency=${this.filterCurrency}`
      }
      this.$axios.get(url)
      .then(res => {
        this.investments = res.data.data;
       
      }) 
    }
  }
};
</script>